import React, { useEffect } from 'react';
import UserContext from 'context/UserContext';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import styles from './style';
import Button from 'storybookComponents/Button';
import { Formik, Form } from 'formik';
import Stepper from 'storybookComponents/Stepper';
import createCampaign from "relay/campaigns/mutations/createCampaign"
import updateCampaign from "relay/campaigns/mutations/updateCampaign"
import abortScheduledCampaign from "relay/campaigns/mutations/abortScheduledCampaign"
import environment from "environments/environment.js"
import { getDefaultValues, updateStepper, parseCampaignPayload, parseDateToString, brToNl, nlToBr } from "./util/index"
import ReferralCampaign from "./Edit"
import Preview from './OmnichannelPreview';
import ScheduleInvite from './ScheduleInvite';
import ToastMessage from "storybookComponents/Toast"
import { getEventRoutesParameters, PREVIEW, SCHEDULE, PUBLISH, getAppPath } from "constants/path";
import { loadProperties } from "relay/common";
import { getCampaign } from "relay/campaigns";
import { scheduleCamgaign } from "relay/invite"
import { getErrorMessage, checkUncatchableError } from "environments/uncatchableErrorStore";
import { getCampaignEditPath } from "constants/path"
import DefaultValues, { rewardFields, defaultReward } from "./default";
import Loader from "storybookComponents/Loader";
import { validationSchema, getUtmLinks } from "./util"
import banners from './base64';

const STEPS = {
  [PREVIEW]: 1,
  [SCHEDULE]: 2
}
var initCampagin;
const Campaign = withStyles(styles)(({ classes, history, setTitle, toggleDrawer, isDrawerOpen, username, isApprover: userIsApprover, settings: approverSettings, loadingSetting, setOriginNavItems, orgLevel, ...props }) => {
  const { subOrgDetails } = React.useContext(UserContext);
  let { id, step: _step } = getEventRoutesParameters();
  const [isActive, setActive] = React.useState("active");
  const [draftCampaign, setDraftCampaign] = React.useState(getDefaultValues(props, defaultReward, rewardFields));
  const [loading, setLoading] = React.useState(false);
  const [toast, setToast] = React.useState({ open: false })
  const [step, setStep] = React.useState()
  const [steps, updateSteps] = React.useState([])
  const [error, setError] = React.useState(null);
  const [scheduleInput, setScheduleInput] = React.useState();
  const [propertyList, setPropertyList] = React.useState([]);
  const [onSaveButtonState, setOnSaveButtonState] = React.useState("active");
  const [loadingProperties, setLoadingProperties] = React.useState(false);
  const [utmCodesLink, setUtmCodeLink] = React.useState();
  const [saveCampaignLoading, setSaveCampaignLoading] = React.useState(false);
  const orgColors = {
    buttonBackgroundColor: subOrgDetails.buttonBackgroundColor,
    buttonBorderColor: subOrgDetails.buttonBorderColor,
    buttonFontColor: subOrgDetails.buttonFontColor,
    fontFamily: subOrgDetails.fontFamily,
    id: subOrgDetails.id,
    linkColor: subOrgDetails.linkColor,
    textColor: subOrgDetails.textColor,
  }
  const updateCampaignData = async (campaign) => {
    // let utmLink = await getUtmLinks(campaign.id);
    // if (utmLink) {
    //   setUtmCodeLink(utmLink)
    // }
    let data = {
      ...campaign,
      image: campaign.image.thumbnailUrl,
      residentDiscountImage: campaign.residentDiscountImage.thumbnailUrl,
      residentInviteImage: campaign.residentInviteImage.thumbnailUrl,
      residentThankYouImage: campaign.residentThankYouImage ? campaign.residentThankYouImage.thumbnailUrl : banners.thankYouBanner,
      emailBody: brToNl(campaign.emailBody),
      residentInviteEmailBody: brToNl(campaign.residentInviteEmailBody),
      residentDiscountEmailBody: brToNl(campaign.residentDiscountEmailBody),
      residentThankYouEmailBody: campaign.residentThankYouEmailBody ? brToNl(campaign.residentThankYouEmailBody) : brToNl(DefaultValues.residentThankYouEmailBody),
      landingPageContent: campaign.landingPageContent ? brToNl(campaign.landingPageContent) : brToNl(DefaultValues.landingPageContent),
      landingPageImage: campaign.landingPageImage ? campaign.landingPageImage.thumbnailUrl : banners.landingBanner,
      landingPageTitle: campaign.landingPageTitle ? campaign.landingPageTitle : DefaultValues.landingPageTitle
    };

    localStorage.setItem("reward", data.reward);
    setDraftCampaign(data);
    initCampagin = data;

    // }
  }


  const fetchUtmLinks = async (id) => {
    try {
      let utmLink = await getUtmLinks(id);
      if (utmLink) {
        setUtmCodeLink(utmLink)
      }
    } catch (err) {
      console.log("Err", err)
    }
  }

  const loadCampaign = async () => {
    try {
      setLoading(true);
      await fetchUtmLinks(id)
      let campaign = await getCampaign(id);
      const uncachebleError = getErrorMessage(checkUncatchableError("getCampaignQuery"));
      if (uncachebleError) {
        setError(uncachebleError || `Something went wrong`, "error");
      }
      else {
        updateCampaignData(campaign);
        updateSteps(updateStepper(STEPS[_step] || 0, id, campaign.inviteScheduleAt))
      }
      setLoading(false);
    }
    catch (err) {
      console.log("err : ", err)
      const uncachebleError = getErrorMessage(checkUncatchableError("getCampaignQuery"));
      if (uncachebleError) {
        setError(uncachebleError || `Something went wrong`, "error");
      }
    }
  }


  const init = async () => {
    if (id) loadCampaign()

    setLoadingProperties(true)
    let list = await loadProperties(subOrgDetails.org.id);
    setPropertyList(list);
    setLoadingProperties(false)
  }

  useEffect(() => {
    if (isDrawerOpen) {
      toggleDrawer();
    }
    if (orgLevel) {
      setOriginNavItems("hyRafMenuOrg")
    } else {
      setOriginNavItems("hyRaf")
    }
    init();
  }, [orgLevel])

  const getButtonText = (step) => {
    switch (step) {
      case 0:
        return "Save & Next"
      case 2:
        return "Schedule"
      default: return "Next"
    }
  }

  useEffect(() => {
    setStep(STEPS[_step] || 0)
    updateSteps(updateStepper(STEPS[_step] || 0, id, draftCampaign.inviteScheduleAt))
  }, [1])


  const showNotification = (message, type) => {
    setToast({
      open: true,
      variant: type,
      message
    })
  }

  const onCancel = () => {
    history.push(getAppPath())
  }

  const onSave = async (values, preventTabChange) => {
    const _property = propertyList.find(e => e.id === values.propertyId);
    let result, nextLink;

    try {
      setOnSaveButtonState("inactive");
      if (id) {
        let payload = { id, propertyId: values.propertyId, title: values.title };
        for (let key in values) {
          if (initCampagin[key] !== values[key]) {
            if (!key.toLowerCase().endsWith("image") || (key.toLowerCase().endsWith("image") && values[key].startsWith("http")))
              payload[key] = values[key];
          }
        }
        if (payload.emailBody)
          payload.emailBody = nlToBr(payload.emailBody);
        if (payload.residentInviteEmailBody)
          payload.residentInviteEmailBody = nlToBr(payload.residentInviteEmailBody);
        if (payload.residentDiscountEmailBody)
          payload.residentDiscountEmailBody = nlToBr(payload.residentDiscountEmailBody)
        if (payload.residentThankYouEmailBody)
          payload.residentThankYouEmailBody = nlToBr(payload.residentThankYouEmailBody)
        if (payload.landingPageContent)
          payload.landingPageContent = nlToBr(payload.landingPageContent)
        if (payload.reward)
          payload.reward = parseFloat(payload.reward)
        result = await updateCampaign(environment, payload);
        if (result.updateHyreferralCampaign) {
          let campaign = result.updateHyreferralCampaign.hyreferralCampaign;
          updateCampaignData(campaign);
          showNotification(`Referral Campaign ${campaign.title} for ${_property.name} has been updated successfully.`, "success")
          setOnSaveButtonState("active");
          updateSteps(updateStepper(1, id, draftCampaign.inviteScheduleAt));
          setStep(1);
        }
      } else {
        setSaveCampaignLoading(true)
        result = await createCampaign(environment, parseCampaignPayload(values, _property.name));
        if (result.createHyreferralCampaign) {
          let campaign = result.createHyreferralCampaign.hyreferralCampaign;
          updateCampaignData(campaign);
          await fetchUtmLinks(campaign.id)
          showNotification(`Referral Campaign ${campaign.title} for ${_property.name} has been created successfully.`, "success")
          setOnSaveButtonState("active");
          setSaveCampaignLoading(false)
          history.push(getCampaignEditPath(campaign.id + "/preview"))
          updateSteps(updateStepper(1, campaign.id, false));
          setStep(1);

        }
      }
    }
    catch (error) {
      console.log("Error : ", error)
      const uncachebleError = getErrorMessage(checkUncatchableError("scheduleCamgaignMutation"));
      if (uncachebleError) {
        showNotification(uncachebleError || `Something went wrong`, "error");
      }
    }
  }

  const onScheduleSuccess = (date) => {
    if (draftCampaign.inviteScheduleAt) {
      showNotification(`Invite for ${draftCampaign.title} is rescheduled successfully.You can edit the reschedule date & time before ${date}.`, "success")

    } else {
      showNotification(`Invite for ${draftCampaign.title} is scheduled successfully.You can edit the schedule date & time before ${date}.`, "success")
    }
    setTimeout(() => {
      history.push(getAppPath())
    }, 5000)
  }

  const abortCampaign = async () => {
    try {
      let payload = {
        id: draftCampaign.abortResidentInviteCampaignId
      }
      const res = await abortScheduledCampaign(environment, payload);
      if (!res.abortScheduled) {
        const uncachebleError = getErrorMessage(checkUncatchableError("abortScheduledCampaignMutation"));
        if (uncachebleError) {
          showNotification(uncachebleError, "error");
        }
      }
    } catch (error) {
      showNotification("Something went wrong", "error");
      console.log("error: ", error)
    }
  }


  const onSchedule = async () => {
    try {
      setActive("inactive");
      if (draftCampaign.inviteScheduleAt) {
        await abortCampaign();
      }
      const res = await scheduleCamgaign(scheduleInput);
      if (res.scheduleResidentInviteHyreferral) {
        onScheduleSuccess(parseDateToString(new Date(scheduleInput.inviteScheduleAt)), res.scheduleResidentInviteHyreferral)
      }
      else {
        const uncachebleError = getErrorMessage(checkUncatchableError("scheduleCamgaignMutation"));
        if (uncachebleError) {
          showNotification(uncachebleError, "error");
        }
        setActive("active");
      }
    }
    catch (error) {
      setActive("active");
      showNotification("Something went wrong", "error");
      console.log("error: ", error)
    }
  }



  const closeToast = () => {
    setTimeout(() => {
      setToast({
        open: false,
        variant: toast.variant
      })
    }, 5000)
  }

  const forceCloseToast = () => {
    setToast({
      open: false,
      variant: toast.variant
    })
  }

  const changeStep = (index) => {
    if (!id && index > 0) return
    setStep(index)
    updateSteps(updateStepper(index, id, draftCampaign.inviteScheduleAt))
  }


  const onSubmit = (values) => {
    switch (step) {
      case 0:
        return onSave(values);
      case 1:
        return changeStep(2)
      case 2:
        return onSchedule()
      default: return ""
    }
  }


  const getSubmitButtonState = () => {
    switch (step) {
      case 0: return isActive === "active" && onSaveButtonState === "active" ? "active" : "inactive"
      case 1: return "active"
      case 2: return scheduleInput && scheduleInput.id && scheduleInput.inviteScheduleAt && isActive === "active" ? "active" : "inactive"
      default: return "inactive"
    }
  }

  const renderForm = (form_props) => {
    if (step === 0) {
      if (Object.keys(form_props.errors).length === 0) {
        setActive("active")
      } else {
        setActive("inactive")
      }
    }


    return (
      <Form className={classes.form}>
        <div className={classes.mainHeader}>
          <Stepper allSteps={steps} onStepCLickedCallback={changeStep} /> {/* TODO: stpes should be checked for stepper bug */}
          {
            step !== 2 && <div className={classes.headerRight}>
              <Button state={getSubmitButtonState()} className={classes.btnStyle} color="darkBlack" variant="tertiary" size="sm" onClick={onCancel}>
                Cancel
              </Button>
              <Button state={getSubmitButtonState()} className={classes.btnStyle} color="hylyBlue" type="submit" variant="primary" size="sm" >
                {getButtonText(step)}
              </Button>
            </div>
          }

        </div>
        <div style={{ width: "100%" }}>
          {
            saveCampaignLoading ? <Loader /> :
              <div>
                {
                  step == 0 &&
                  <ReferralCampaign orgLevel={orgLevel} showNotification={showNotification} orgColors={orgColors} id={id} setTitle={setTitle} utmCodesLink={utmCodesLink} loadProperties={loadProperties} propertyList={propertyList} setActive={setActive} {...form_props} onCancel={onCancel} />

                }
                {
                  step == 1 && id &&
                  <Preview
                    orgColors={orgColors}
                    values={draftCampaign}
                    setTitle={setTitle}
                    id={id}
                    title={draftCampaign.title}
                    classes={classes} />
                }
                {
                  step == 2 &&
                  <ScheduleInvite propertyName={draftCampaign.propertyName} image={draftCampaign.image} emailSms={draftCampaign.emailSms} shortEnrollUrl={draftCampaign.shortEnrollUrl} inviteScheduledAt={draftCampaign.inviteScheduleAt} setTitle={setTitle} title={draftCampaign.title} subject={draftCampaign.emailSubject} id={id} showNotification={showNotification} getSubmitButtonState={getSubmitButtonState} onScheduleSMSEmail={onSchedule} onChange={setScheduleInput} residentInviteCampaignTested={draftCampaign.residentInviteCampaignTested} username={username} />

                }
              </div>
          }
        </div>
      </Form >
    )
  }

  if (loading || loadingSetting || loadingProperties) return <Loader />
  if (error) return <div className={classes.loader}>{error}</div>
  return (
    <div>
      <ToastMessage
        variant={toast.variant}
        message={toast.message}
        open={toast.open}
        onCloseCallback={closeToast}
        onForceCloseCallback={forceCloseToast}
      />

      <Formik
        initialValues={draftCampaign}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {renderForm}
      </Formik>


    </div>
  );
})

Campaign.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  dateTime: PropTypes.string,
  body: PropTypes.string,
};

Campaign.defaultProps = DefaultValues;
export default Campaign;
